import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { IonicModule, ModalController } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "codere-bu-modal",
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule],
  templateUrl: "./bu-modal.component.html",
  styleUrl: "./bu-modal.component.scss",
})
export class BuModalComponent {
  modalCtrl = inject(ModalController);

  async accept() {
    await this.modalCtrl.dismiss(true);
  }

  async cancel() {
    await this.modalCtrl.dismiss(false);
  }
}
